import ColorAndImagePicker from './ColorAndImageAnchor';

export default ColorAndImagePicker;
